/** Validate per-album results before showing success to the user. */
export function albumApprovalFeedback(result, requestedIds, approved) {
    const invalid = () => {
        const error = new Error("Chưa nhận đủ kết quả duyệt album. Vui lòng làm mới danh sách để kiểm tra.");
        error.code = "ALBUM_APPROVAL_INVALID_RESULT";
        throw error;
    };
    if (!result || !Array.isArray(result.processedAlbums) ||
        !Array.isArray(result.notFoundAlbumIdxs)) invalid();
    const expected = new Set(requestedIds.map(String));
    if (expected.size === 0) invalid();
    const received = new Set();
    for (const state of result.processedAlbums) {
        if (!state || typeof state.idx !== "string" || !expected.has(state.idx) ||
            received.has(state.idx) || typeof state.approved !== "boolean" ||
            !Number.isInteger(state.pendingPictureCount) || state.pendingPictureCount < 0 ||
            state.needsApproval !== (!state.approved || state.pendingPictureCount > 0)) invalid();
        received.add(state.idx);
    }
    for (const idx of result.notFoundAlbumIdxs) {
        if (typeof idx !== "string" || !expected.has(idx) || received.has(idx)) invalid();
        received.add(idx);
    }
    if (received.size !== expected.size) invalid();
    const completed = result.processedAlbums.filter((state) => state.approved === approved).length;
    const verb = approved ? "duyệt" : "hủy duyệt";
    if (completed === expected.size) {
        return {type: "success", message: approved ? "Duyệt album thành công!" : "Hủy duyệt album thành công!"};
    }
    if (completed === 0) {
        return {type: "error", message: `Không có album nào được ${verb}. Album không còn khả dụng hoặc trạng thái đã thay đổi. Vui lòng kiểm tra lại danh sách.`};
    }
    return {
        type: "warning",
        message: `Đã ${verb} ${completed}/${expected.size} album. ${expected.size - completed} album không còn khả dụng hoặc trạng thái đã thay đổi; vui lòng kiểm tra lại danh sách.`,
    };
}
